import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core";
import NotificationProvider from "components/NotificationProvider";
import { useUpdateLoadMutation } from "features/loads/loadsSlice";
import { useGetLotsQuery } from 'features/lots/lotSlice';
import { cloneDeep } from "lodash";
import { useEffect, useState } from "react";
import GroupLoadForm from "../CreateLoadForm";
import CreateLoadFormOld from '../CreateLoadForm/CreateLoadForm_old';
import { isValidPhoneNumber } from 'react-phone-number-input';

const EditLoadLeg = ({ open, setOpen, loadGroup, loadIndex }) => {

    let [updateLoad, { isLoading: saving }] = useUpdateLoadMutation();
    let { data: lots, error: lotError, isLoading: isLoadingLots } = useGetLotsQuery();

    const [loadGroupToEdit, setLoadGroupToEdit] = useState({})

    const lotsLookup = lots?.reduce(function (map, obj) {
        map[obj.id] = obj;
        return map;
    }, {});

    useEffect(() => {
        if (loadGroup) {
            setLoadGroupToEdit(cloneDeep(loadGroup ?? {}));
        }
    }, [loadGroup]);

    const onChange = (changedGroup) => {
        setLoadGroupToEdit(changedGroup);
    };

    const isValid = () => {
        const load = loadGroupToEdit?.loads?.[loadIndex];
        var pckOwnedByTenant = lotsLookup?.[load?.pickupLocationId]?.ownedByTenant;
        var deliveryOwnedByTenant = lotsLookup?.[load?.deliveryLocationId]?.ownedByTenant;
        
        const res = load?.pickupStartDate &&
            load?.deliveryStartDate &&

            (deliveryOwnedByTenant || (
                load?.deliveryPocName &&
                load?.deliveryPocEmail &&
                isValidPhoneNumber(load?.deliveryPocPhone ?? "") &&
                (!load?.deliveryPocPhone2 || isValidPhoneNumber(load?.deliveryPocPhone2 ?? "")) &&
                (!load?.deliveryPocPhone3 || isValidPhoneNumber(load?.deliveryPocPhone3 ?? "")))) &&
            (pckOwnedByTenant || (load?.pickupPocName &&
                load?.pickupPocEmail &&
                isValidPhoneNumber(load?.pickupPocPhone ?? "") &&
                (!load?.pickupPocPhone2 || isValidPhoneNumber(load?.pickupPocPhone2 ?? "")) &&
                (!load?.pickupPocPhone3 || isValidPhoneNumber(load?.pickupPocPhone3 ?? "")))) &&
            ((load.pickupLocationId && load.pickupLocationId !== 0 && !load?.originNewLot) ||
                (load?.originNewLot &&
                    load.pickupName &&
                    load.pickupNodeName &&
                    load.pickupAddress &&
                    load.pickupCity &&
                    load.pickupState &&
                    load.pickupZip 
                    )) &&
            ((load.deliveryLocationId && load.deliveryLocationId !== 0 && !load?.destinationNewLot) ||
                (load?.destinationNewLot &&
                    load.deliveryName &&
                    load.deliveryNodeName &&
                    load.deliveryAddress &&
                    load.deliveryCity &&
                    load.deliveryState &&
                    load.deliveryZip));
        return res;
    };

    const onSubmit = async () => {
        const validate = isValid();

        const newLoad = loadGroupToEdit?.loads?.[loadIndex];
        let result = await updateLoad(newLoad)
        if (result?.error) {
            NotificationProvider.error(`Failed to update the load`)
        } else {
            NotificationProvider.success(`Successfully updated the load`);
            setOpen(false);
        }
    };

    return (
        <Dialog open={open} aria-labelledby='dialog-title' maxWidth='md'>
            <DialogTitle id={'dialog-title'} >Edit Load</DialogTitle>
            <DialogContent>
                <>
                    {loadGroup?.loads?.[loadIndex]?.moveType ?
                        <CreateLoadFormOld // for really old loads (before we changed the move types)
                            handleClose={() => setOpen(false)}
                            loadToEdit={loadGroup?.loads?.[loadIndex]}
                        /> :
                        <GroupLoadForm
                            legIndex={loadIndex}
                            handleClose={() => setOpen(false)}
                            loadGroup={loadGroupToEdit}
                            setLoadGroup={onChange}
                        />
                    }</>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setOpen(false)} color='primary'>
                    Cancel
                </Button>
                <Button variant="contained" disabled={saving || !isValid()} onClick={onSubmit} color='primary'>
                    {saving ? 'Saving...' : 'Save'}
                </Button>
            </DialogActions>
        </Dialog>

    )
}
export default EditLoadLeg;